import { apiClient } from '@isocel/front-common';

import { BaseModel } from './types';

export const fetchWarehouses = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/warehouses`);
    return (data as any[])
        .map((w) => ({ ...w, id: w.id || w._id } as BaseModel))
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
};
